import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import BuildIcon from '@material-ui/icons/Build';
import { IconClipboard, IconTruck } from "icons";
import AuditsTask from "./components/TaskItem/TaskTypes/AuditsTask";
import InspectionTask from "./components/TaskItem/TaskTypes/InspectionTask";
import LoadsTask from "./components/TaskItem/TaskTypes/LoadsTask";
import MechanicalTask from "./components/TaskItem/TaskTypes/MechanicalTask";
import UserTask from "./components/TaskItem/TaskTypes/UserTask";
import WashTask from "./components/TaskItem/TaskTypes/WashTask";

export const TaskTypes = {
    WASH: 1,
    LOADS: 2,
    Inspection: 3,
    Audits: 4,
    Mechanicals: 5,
    UserTask: 6,
}

export const TaskEntityTypes = {
    ASSET: 1
}

export const TaskStatuses = {
    OPEN: 1
}


export const TaskSetup = {
    [TaskTypes.WASH]: {
        label: 'Wash',
        noteEntityTypeId: 3,
        component: (task) => <WashTask task={task} />,
        link: (task) => `/workorder/${task?.workOrderId}`,
        icon: <img src="/icons/icon-detailing.svg" />
    },
    [TaskTypes.LOADS]: {
        label: 'Transport',
        noteEntityTypeId: 7,
        component: (load) => <LoadsTask task={load} />,
        link: (task) => `/load/group/${task?.groupId}`,
        icon: <IconTruck />
    },
    [TaskTypes.Inspection]: {
        label: 'Inspection',
        noteEntityTypeId: 0,
        component: (load) => <InspectionTask task={load} />,
        link: (task) => ``,
        icon: <img src="/icons/icon-inspect.svg" />,
    },
    [TaskTypes.Audits]: {
        label: 'Audit',
        noteEntityTypeId: 0,
        component: (audit) => <AuditsTask task={audit} />,
        link: () => `/assets/audit`,
        icon: <AssignmentTurnedInOutlinedIcon />,
    },
    [TaskTypes.Mechanicals]: {
        label: 'Mechanicals',
        noteEntityTypeId: 4,
        component: (a) => <MechanicalTask task={a} />,
        link: (task) => `/workorder/${task?.workOrderId}`,
        icon: <BuildIcon />,
    },
    [TaskTypes.UserTask]: {
        label: '',
        noteEntityTypeId: 0,
        component: (a) => <UserTask task={a} />,
        //link: (task) => `/usertask/${task?.id}`,
        icon: <IconClipboard />
    }
}